import React from 'react'
import { UserMessage } from '../util-cmps/user-message'

export const GlueTriggerResult: React.FC<{ result: any }> = ({ result }) => {
    const detail = result.detail || result
    const changed: string[] = [...(detail.updated || []), ...(detail.activated || []), ...(detail.deactivated || []), ...(!result.failed ? detail.created || [] : [])]
    const failed = detail.errors || []
    const rollbackErrors = detail.rollback_errors || []
    const restored: string[] = detail.restored || []
    const untouched: string[] = detail.not_attempted || []
    return <UserMessage type={result.failed ? 'danger' : 'success'} inline label="Last schedule save result" role={result.failed ? 'alert' : 'status'}>
        <p>{result.failed
            ? detail.partial_save ? 'Save partially applied. Check the current AWS state below before retrying.'
                : detail.original_preserved ? 'Save failed. The original configuration and active status were preserved.'
                : 'Save failed. Check the current AWS state below before retrying.'
            : detail.deletion_requested?.length ? 'Save applied. AWS accepted the deletion requests.' : 'Save applied and verified in AWS.'}</p>
        {typeof detail === 'string' && <p>{detail}</p>}
        {detail.error && <p>{detail.error}</p>}
        {changed.length > 0 && <p>Applied and verified: {changed.join(', ')}</p>}
        {detail.deletion_requested?.length > 0 && <p>Deletion requested: {detail.deletion_requested.join(', ')}</p>}
        {detail.deletion_unknown?.length > 0 && <p>Deletion unconfirmed: {detail.deletion_unknown.join(', ')}. Refresh from AWS before retrying.</p>}
        {detail.deleted?.length > 0 && <p>Removed and verified: {detail.deleted.join(', ')}</p>}
        {result.failed && detail.created?.length > 0 && <p>Added triggers still present: {detail.created.join(', ')}</p>}
        {detail.unknown_creation?.length > 0 && <p>Creation unconfirmed: {detail.unknown_creation.join(', ')}. Refresh from AWS before retrying.</p>}
        {restored.length > 0 && <p>Original settings verified: {restored.join(', ')}</p>}
        {untouched.length > 0 && <p>Not attempted: {untouched.join(', ')}</p>}
        {failed.length > 0 && <ul aria-label="Failed changes">{failed.map((e: any, index: number) =>
            <li key={index}>{e.trigger_name}: {e.error}</li>)}</ul>}
        {rollbackErrors.length > 0 && <ul aria-label="Restoration unconfirmed">{rollbackErrors.map((e: any, index: number) =>
            <li key={index}>{e.trigger_name}: restoration could not be confirmed — {e.error}</li>)}</ul>}
    </UserMessage>
}
